"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_OP = void 0;
exports.configure = configure;
exports.disconnect = disconnect;
exports.state = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.values.js");
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var defaults = _lodashReplacement.default.defaults;
var _defaults = {
  enabled: true,
  filterMode: "whitelist",
  filterDirection: "both",
  sendPreservedToRemote: true,
  queueingEnabled: true
};
var NO_OP = function NO_OP() {};
exports.NO_OP = NO_OP;
var state = {
  _clients: [],
  _transports: {},
  _ready: false,
  _inboundQueue: [],
  _outboundQueue: [],
  _signalQueue: [],
  _config: _defaults
};
exports.state = state;
function configure(cfg) {
  if (cfg && cfg.filterMode && cfg.filterMode !== "blacklist" && cfg.filterMode !== "whitelist") {
    throw new Error("postal.fedx filterMode must be 'blacklist' or 'whitelist'.");
  }
  if (cfg) {
    state._config = defaults(cfg, _defaults);
  }
  return state._config;
}
function disconnect(options) {
  options = options || {};
  var trans = state._transports;
  if (options.transport) {
    trans = {};
    trans[options.transport] = state._transports[options.transport];
  }
  Object.values(trans).forEach(function (t) {
    t.disconnect({
      target: options.target,
      instanceId: options.instanceId,
      doNotNotify: !!options.doNotNotify
    });
  });
}